import React from 'react'
import { useStaticQuery, graphql } from "gatsby"
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/blur-up/ls.blur-up';
// import 'styles/blurup.scss';

// import Img from "gatsby-image"

import { buildURL } from 'react-imgix';


/*
.ls-blur-up-is-loading, .lazyload:not([src]) {
	visibility: hidden;
}
.ls-blur-up-img {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: block;
	object-fit: cover;
}

.ls-blur-up-img {
	filter: blur(10px);
	opacity: 1;
	transition: opacity 10000ms, filter 15000ms;
}

.ls-blur-up-img.ls-inview.ls-original-loaded {
	opacity: 0;
	filter: blur(5px);
}
 */

const Image = (props) => {
	const data = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					imgCDN
				}
			}
		}
	`);
	const domain = data.site.siteMetadata.imgCDN;
	let imagePath = (props.src ? props.src.replace(/^\//, '') : 'images/placeholder.jpg');
	if (imagePath.indexOf('/') === -1)imagePath = `images/${imagePath}`;
	imagePath = `${domain}/${imagePath}`;

	const alt = props.alt||'';
	const className = (props.className||'').split(' ');
	const sizes = props.sizes||[
		480,
		960,
		1000,
	];
	let width = null;
	if ('auto'.localeCompare(props.width, undefined, {sensitivity: 'base'}) !== 0) {
		width = props.width||1920;
	}
	let lowQualityProps = {
		auto: 'compress,format',
	}
	let fallbackProps = {
		auto: 'compress',
	}
	if (width) {
		lowQualityProps.w = width*.05;
		fallbackProps.w = width;
	}
	else {
		lowQualityProps.w = 64;
		fallbackProps.maxWidth = 1920;
	}
	const lowQuality = buildURL(imagePath, lowQualityProps);
	const fallback = buildURL(imagePath, fallbackProps);
	const srcset = [];
	const srcsetWebP = [];
	let sizesAttribute;
	sizes.forEach(function(size){
		srcset.push(`${buildURL(imagePath, {
			maxWidth: size,
			auto: 'compress,format',
		})} ${size}w`);
	});
	sizes.forEach(function(size){
		srcsetWebP.push(`${buildURL(imagePath, {
			maxWidth: size,
			auto: 'compress',
			format: 'webp',
		})} ${size}w`);
	});
	sizesAttribute = `(max-width: ${sizes[sizes.length-1]}px) 100vw, ${sizes[sizes.length-1]}px`;

	// className.push('lazyload');

	return (
		<img
			className={className.join(' ')}
			alt={alt}
			src={fallback}
			onLoad={props.onLoad}
		 />
	)
}

/*
		<div style={{
			position: 'relative',
			overflow: 'hidden',
		}}>
			<picture>
				<source
					type="image/webp"
					srcSet={srcsetWebP.join(', ')}
					sizes={sizesAttribute}
				/>
				<source
					srcSet={srcset.join(', ')}
					sizes={sizesAttribute}
				/>
				<img
					className={className.join(' ')}
					alt={alt}
					data-src={fallback}
					data-srcset={srcset.join(', ')}
					data-sizes={sizesAttribute}
					data-lowsrc={lowQuality}
					style={{
						top: 0,
						left: 0,
						maxWidth: '100%',
						height: 'auto',
						objectFit: 'cover',
						objectPosition: 'center center',
					}}
				 />
			</picture>
		</div>

 */


export default Image
